exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Notice{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.Notice .ant-card-body{padding:15px 30px 18px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./apps/pages/main/layout/css/Notice.less
// module id = 1581
// module chunks = 1